module.exports = __webpack_public_path__ + "img/Willing Risk Taker.3cc18a42.svg";